import { useEffect } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setSendSmsDialog,
  resetForm,
  SimCard,
} from "../../../../app/slices/simCardSlice";
import { Controller, useForm } from "react-hook-form";
import {
  HiOutlineEnvelope,
  HiOutlineChatBubbleBottomCenterText,
} from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const SendSmsForm = () => {
  const _SimCard = useSelector((state) => state.simCard.simCard);
  const _port = useSelector((state) => state.simCard.simCard.simPort);
  const loading = useSelector((state) => state.simCard.simCard.loading);
  const {
    control,
    handleSubmit,
    setValue,
    formState: { isDirty },
  } = useForm({
    defaultValues: {
      message: "",
      send_to: "",
      port: _SimCard.form.port,
    },
  });
  const onSubmit = (data) => {
    data.port = _port;
    dispatch(SimCard.sendSms(data));
  };
  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
  }, []);

  const dispatch = useDispatch();

  const handleDialog = () => {
    dispatch(setSendSmsDialog());
  };
  return (
    <FormDialog
      open={_SimCard.sendSmsDialog}
      onClose={() => {
        handleDialog();
      }}
      icon={<HiOutlineEnvelope />}
      title="اضافة رسالة"
      subtitle="أدخل رقم المرسل اليه ونص الرسالة لإرسالها"
      onSubmit={handleSubmit(onSubmit)}
      saving={loading}
      saveDisabled={!isDirty}
      loading={loading}
    >
      <SectionCard
        icon={<HiOutlineChatBubbleBottomCenterText />}
        title="معلومات الرسالة"
      >
        <Grid item xs={12}>
          <Controller
            name="send_to"
            control={control}
            render={({ field }) => (
              <TextField
                required
                value={field.value}
                size="small"
                label="المرسل اليه"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="message"
            control={control}
            render={({ field }) => (
              <TextField
                required
                value={field.value}
                multiline
                rows={4}
                size="small"
                label="الرسالة"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default SendSmsForm;
